import moment from "moment";
import { TSchedule } from "./types";
import { t } from "i18next";

export const nextScheduleAsString = (
  nextSchedule: TSchedule | undefined
): string | undefined => {
  if (nextSchedule) {
    return t(nextSchedule.state + " at WHAT", {
      what: moment(nextSchedule.timestamp).format("HH:mm"),
    });
  }
  return undefined;
};
